// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "* {\n\tpadding: 0;\n\tmargin: 0;\n\tfont-family: 'Raleway', sans-serif;\n}\n\n*::-webkit-scrollbar {\n\twidth: 10px;\n\toverflow: overlay;\n}\n\n*::-webkit-scrollbar-thumb {\n\tbackground: #83A4CE;\n\tborder-radius: 4px;\n}\n\n*::-webkit-scrollbar-track {\n\tbackground: #c9d7e8;\n}\n\n/*html {\n\toverflow-y: scroll;\n}*/\n\n/*img {\n\toverflow: hidden;\n\tobject-fit: contain;\n}*/\n", ""]);
// Exports
module.exports = exports;
